/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SearchPlayerMobileRequestContent
 */
export interface SearchPlayerMobileRequestContent {
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerMobileRequestContent
     */
    searchTerm?: string;
}


/**
 * Check if a given object implements the SearchPlayerMobileRequestContent interface.
 */
export function instanceOfSearchPlayerMobileRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerMobileRequestContentFromJSON(json: any): SearchPlayerMobileRequestContent {
    return SearchPlayerMobileRequestContentFromJSONTyped(json, false);
}

export function SearchPlayerMobileRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerMobileRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'searchTerm': !exists(json, 'searchTerm') ? undefined : json['searchTerm'],
    };
}

export function SearchPlayerMobileRequestContentToJSON(value?: SearchPlayerMobileRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'searchTerm': value.searchTerm,
    };
}

